import classNames from 'classnames';
import React, { useCallback, useMemo, useState } from 'react';

import { ProfileIcon } from 'common/components/ProfileIcon/ProfileIcon.component';

import { useBowser, useI18n } from 'common/hooks';
import { useCustomer } from 'common/hooks/useCustomer/useCustomer.hook';
import svgIcons from 'common/svgIcons';

import { AuthProtectedButton } from '../AuthProtectedLink/AuthProtectedButton.component';
import Sidebar from '../Sidebar/Sidebar.component';
import SvgIconUrl from '../SvgIconUrl/SvgIconUrl.component';
import { Tooltip } from '../Tooltip/Tooltip.component';
import { UserCard } from '../UserCard';
import './UserMenu.css';

export const UserMenu = React.memo(() => {
  const [enabled, toggleEnabled] = useState(false);

  const { translate } = useI18n();

  const { isAuthenticated, logOut } = useCustomer();

  const enable = useCallback(() => toggleEnabled(true), []);
  const disable = useCallback(() => toggleEnabled(false), []);

  const { isMobile } = useBowser();

  const signClassNames = classNames({
    sidebar__item: true,
    Body2_light_14: isMobile,
    signout: isAuthenticated,
    signin: !isAuthenticated,
  });

  const iconClassNames = classNames({
    sign__icon: true,
    signout__icon: isAuthenticated,
    signin__icon: !isAuthenticated,
  });

  const overlay = useMemo(
    () => (
      <div onClick={disable}>
        <UserCard />
        <Sidebar className='sidebar-menu' bottom top={false} />
        <AuthProtectedButton>
          <span className={signClassNames} onClick={logOut}>
            <SvgIconUrl className={iconClassNames} symbol={svgIcons.SignOut()} />
            {isAuthenticated && <div className='sidebar__label Body3_reg_16'>{translate('mobile:signout:title')}</div>}
            {!isAuthenticated && <div className='sidebar__label Body3_reg_16'>{translate('mobile:signin:title')}</div>}
          </span>
        </AuthProtectedButton>
      </div>
    ),
    [disable, iconClassNames, isAuthenticated, logOut, signClassNames, translate],
  );

  return (
    <Tooltip
      placement='topLeft'
      trigger={['click']}
      overlayClassName='user-menu light'
      overlay={overlay}
      enabled={enabled}
    >
      <div onMouseOver={enable} data-test='user-menu-profile-icon'>
        <ProfileIcon />
      </div>
    </Tooltip>
  );
});
